<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>Evidenca opravljenega dela</h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <Loading :active.sync="isLoading"
                         :can-cancel="false"
                         :is-full-page="false"></Loading>

                <!--                {{workHoursReports}}-->
                <!--                mesec: {{$store.getters.getCurrentlySelectedMonth}}, leto: {{$store.getters.getCurrentlySelectedYear}}, uporabnik: {{$store.getters.getCurrentlySelectedUser}}-->

                <b-form-group
                        label="Izberi mesec in leto"
                        label-for="month"
                >

                    <div class="row">
                        <div class="col-md-4">
                            <v-select
                                    v-model="month"
                                    placeholder="mesec"
                                    id="month"
                                    name="month"
                                    label="name"
                                    :reduce="item => item.id"
                                    :options="[
                                {id: 1, name: 'januar'},
                                {id: 2, name: 'februar'},
                                {id: 3, name: 'marec'},
                                {id: 4, name: 'april'},
                                {id: 5, name: 'maj'},
                                {id: 6, name: 'junij'},
                                {id: 7, name: 'julij'},
                                {id: 8, name: 'avgust'},
                                {id: 9, name: 'september'},
                                {id: 10, name: 'oktober'},
                                {id: 11, name: 'november'},
                                {id: 12, name: 'december'}
                            ]"
                                    @input="$store.dispatch('setCurrentlySelectedMonth', (month - 1)); retrieveWorkHoursReports()"
                            >

                                <span slot="no-options">Ni zadetkov.</span>

                            </v-select>
                        </div>
                        <div class="col-md-4 offset-md-1">
                            <v-select
                                    v-model="year"
                                    placeholder="leto"
                                    id="year"
                                    name="month"
                                    label="name"
                                    :reduce="item => item.id"
                                    :options="[
                                {id: 2018, name: '2018'},
                                {id: 2019, name: '2019'},
                                {id: 2020, name: '2020'},
                                {id: 2021, name: '2021'},
                                {id: 2022, name: '2022'},
                                {id: 2023, name: '2023'},
                                {id: 2024, name: '2024'},
                                {id: 2025, name: '2025'},
                                {id: 2026, name: '2026'},
                            ]"
                                    @input="$store.dispatch('setCurrentlySelectedYear', year); retrieveWorkHoursReports()">

                                <span slot="no-options">Ni zadetkov.</span>

                            </v-select>
                        </div>

                        <div class="col-md-3">
                            <a class="btn btn-primary btn-sm text-white d-block" @click="generatePdf"><i
                                    class="fas fa-file-pdf"></i> Prenesi poročilo</a>
                        </div>
                    </div>

                </b-form-group>

                <div class="row">
                    <div class="col-md-9">

                        <div>
                            <b-tabs content-class="mt-3">
                                <b-tab title="Prikaz v tabeli" @click="$store.dispatch('setCurrentlySelectedViewMode', 'list')"  :active="$store.getters.getCurrentlySelectedViewMode === 'list'">
                                    <vue-good-table
                                            styleClass="vgt-table table table-hover table-striped"
                                            :columns="columns"
                                            :rows="workHoursReports"
                                            :search-options="{
                                                        enabled: true,
                                                        skipDiacritics: true,
                                                        placeholder: 'vnesi iskalni pojem',
                                                    }"
                                            :sort-options="{
                                                        enabled: true,
                                                      }">

                                        <div slot="emptystate">
                                            <div class="text-center text-muted font-weight-light"><i
                                                    class="fa fa-exclamation-triangle"></i>
                                                <em>Ni podatkov.</em></div>
                                        </div>

                                        <template slot="table-row" slot-scope="props">
                                            <span v-if="props.column.field == 'date'">
                                                {{moment.unix(props.row.date.seconds).format('DD. MM. YYYY')}}
                                            </span>

                                            <span v-else-if="props.column.field == 'type'">
                                                <div class="label" :class="props.row.type.split(' ').join('_')">{{props.row.type}}</div>
                                            </span>

                                            <span v-else-if="props.column.field == 'duration'">
                                                {{props.row.duration}}
                                            </span>

                                            <span v-else-if="props.column.field == 'id'">

                                                <router-link
                                                        :to="{ name: 'EditWorkHoursReport', params: {id: props.row.id, readonly: true }}"
                                                        class="btn btn-info btn-sm text-white">
                                                    <i class="fa fa-eye"></i> Poglej</router-link>

                                                <router-link
                                                        :to="{ name: 'EditWorkHoursReport', params: {id: props.row.id }}"
                                                        class="btn btn-primary btn-sm text-white">
                                                    <i class="fa fa-edit"></i> Uredi</router-link>

                                                <a class="btn btn-danger btn-sm text-white"
                                                   @click="deleteWorkHourReportConfirmation(props.row)"><i
                                                        class="fa fa-trash"></i> Odstrani</a>
                                            </span>

                                        </template>
                                    </vue-good-table>
                                </b-tab>
                                <b-tab title="Koledarski prikaz" @click="$store.dispatch('setCurrentlySelectedViewMode', 'calendar')" :active="$store.getters.getCurrentlySelectedViewMode === 'calendar'">

                                    <FullCalendar
                                            ref="fullCalendar"
                                            defaultView="dayGridMonth"
                                            :plugins="calendarPlugins"
                                            :weekends="true"
                                            :first-day="1"
                                            :events="events"
                                            :default-date="defaultDate"
                                            :locale="'sl'"
                                            :lang="'sl'"
                                            :height="'auto'"
                                            @dateClick="handleCalendarDateClick"
                                            @eventClick="handleEventClick"
                                            @datesRender="handleCalendarDatesRender"
                                            @dayRender="handleCalendarDayRender"

                                    />
                                </b-tab>
                            </b-tabs>
                        </div>

                      <div class="row">
                        <div class="col-md-12 mt-3 mb-5">

                          <router-link :to="{ name: 'EditWorkHoursReport' }" class="btn btn-success">
                            <i class="fa fa-plus"></i> Dodaj zapis v evidenco
                          </router-link>

                        </div>
                      </div>

                    </div>

                    <div class="col-md-3">
                        <div class="alert alert-info">
                            <dl class="row mb-0">
                                <dt class="col-sm-8">Redno delo</dt>
                                <dd class="col-sm-4">{{workHoursTotal}}</dd>

                                <dt class="col-sm-8">Praznik</dt>
                                <dd class="col-sm-4">{{holidaysTotal}}</dd>

                                <dt class="col-sm-8">Letni dopust</dt>
                                <dd class="col-sm-4">{{vacationsTotal}}</dd>

                                <dt class="col-sm-8">Bolniški dopust</dt>
                                <dd class="col-sm-4">{{sickLeaveTotal}}</dd>

                                <dt class="col-sm-8">Neplačan dopust</dt>
                                <dd class="col-sm-4">{{unpaidLeaveTotal}}</dd>
                            </dl>
                        </div>

                        <div class="alert alert-warning mt-3">
                            <h5>Stanje nadur za leto {{year}}</h5>
                            <dl class="row mb-0">
                                <dt class="col-sm-8">Zabeležene nadure</dt>
                                <dd class="col-sm-4">{{overtimeEarnedTotal}}</dd>

                                <dt class="col-sm-8">Koriščene nadure</dt>
                                <dd class="col-sm-4">{{overtimeUsedTotal}}</dd>

                                <dt class="col-sm-8 mb-0">Trenutno stanje nadur</dt>
                                <dd class="col-sm-4 mb-0">{{overtimeBalance}}</dd>
                            </dl>
                            <div class="small text-muted mt-2">
                                Stanje nadur se ponastavlja vsako leto (1. januarja).
                            </div>
                        </div>

                        <div class="alert alert-success mt-3">
                            <h5>Stanje dopusta za leto {{year}}</h5>
                            <dl class="row mb-0">
                                <dt class="col-sm-8">Skupno dni dopusta</dt>
                                <dd class="col-sm-4">{{vacationDaysTotal}}</dd>

                                <dt class="col-sm-8">Koriščeni dnevi</dt>
                                <dd class="col-sm-4">{{vacationDaysUsed}}</dd>

                                <dt class="col-sm-8 mb-0">Preostali dnevi</dt>
                                <dd class="col-sm-4 mb-0">{{vacationDaysRemaining}}</dd>
                            </dl>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

</template>

<script>
  import firebase from 'firebase'
  import {db} from '../../main'
  import {VueGoodTable} from 'vue-good-table'
  import 'vue-good-table/dist/vue-good-table.css'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import {add} from 'timelite/time'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'
  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import interactionPlugin from '@fullcalendar/interaction';

  export default {
    name: 'WorkHoursReport',
    components: {
      VueGoodTable,
      Loading,
      vSelect,
      FullCalendar
    },
    data() {
      return {
        isLoading: false,
        month: parseInt(this.$store.getters.getCurrentlySelectedMonth) + 1,
        year: parseInt(this.$store.getters.getCurrentlySelectedYear),
        defaultDate: this.moment().set({
          year: this.$store.getters.getCurrentlySelectedYear,
          month: this.$store.getters.getCurrentlySelectedMonth
        }).format('YYYY-MM-DD'),
        selectedUser: this.$store.getters.getCurrentlySelectedUser,
        currentlySelectedViewMode: this.$store.getters.getCurrentlySelectedViewMode,
        users: this.$store.getters.getUsers,
        workHoursReports: [],
        events: [],
        calendarPlugins: [dayGridPlugin, interactionPlugin],
        columns: [
          {
            label: 'Datum',
            field: 'date',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Tip dela',
            field: 'type',
            type: 'text',
            sortable: true,
          },
          {
            label: 'število ur',
            field: 'duration',
            type: 'text',
            sortable: true,
          },
          {
            label: 'Akcije',
            field: 'id',
            type: 'text',
            sortable: false,
            width: '300px'
          }
        ],
        workHoursTotal: '0:0',
        holidaysTotal: '0:0',
        vacationsTotal: '0:0',
        sickLeaveTotal: '0:0',
        unpaidLeaveTotal: '0:0',
        overtimeEarnedTotal: '0:0',
        overtimeUsedTotal: '0:0',
        overtimeBalance: '0:0',
        overtimeBalanceHistory: [],
        vacationDaysTotal: 0,  // No default value, will be loaded from Firestore
        vacationDaysUsed: 0,
        vacationDaysRemaining: 0,
        vacationBalance: {}
      }
    },
    mounted() {
      const _this = this

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers
        })
      }

      _this.retrieveWorkHoursReports()
      _this.retrieveOvertimeBalanceHistory()
      _this.retrieveVacationAllowance()
    },
    methods: {

      generatePdf() {
        const _this = this;

        // Create PDF with UTF-8 support
        let doc = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4'
        });

        // Helper function to replace Slovenian characters with ASCII equivalents
        // since jsPDF doesn't handle them well
        function normalizeText(text) {
          // Ensure the text is a string
          if (typeof text !== 'string') {
            return String(text);
          }

          // Replace Slovenian characters with their ASCII equivalents
          return text
            .replace(/č/g, 'c').replace(/Č/g, 'C')
            .replace(/ć/g, 'c').replace(/Ć/g, 'C')
            .replace(/ž/g, 'z').replace(/Ž/g, 'Z')
            .replace(/š/g, 's').replace(/Š/g, 'S')
            .replace(/đ/g, 'd').replace(/Đ/g, 'D');
        }

        let body = [];
        let userId = _this.$store.getters.getCurrentlySelectedUser;
        let month = _this.moment.months(_this.month - 1);

        _this.workHoursReports.forEach(function (report, i) {
          // For the work type, we need to manually replace problematic entries
          let workType = report.type;
          if (workType === 'beleženje nadur') workType = 'belezenje nadur';
          if (workType === 'koriščenje nadur') workType = 'koriscenje nadur';
          if (workType === 'bolniški dopust') workType = 'bolniski dopust';
          if (workType === 'neplačan dopust') workType = 'neplacan dopust';

          body.push([
            i + 1,
            _this.moment.unix(report.date.seconds).format('DD. MM. YYYY'),
            normalizeText(_this.getReadableUser(report.userId)),
            workType,
            report.duration
          ]);
        });

        // Title
        const title = month.charAt(0).toUpperCase() + month.slice(1) + ' ' + _this.year + ':\nEvidenca ur za osebo ' + normalizeText(_this.getReadableUser(userId));

        doc.autoTable({
          theme: 'plain',
          margin: {top: 15},
          head: [[title]],
          body: [],
          styles: { font: 'helvetica', fontStyle: 'normal' },
          headStyles: { fontSize: 12, fillColor: [255, 255, 255], textColor: [0, 0, 0] }
        });

        // Regular hours
        doc.autoTable({
          tableWidth: 'wrap',
          margin: {top: 10},
          head: [['Tip', 'Ure (H:M)']],
          body: [
            ['Redno delo', _this.workHoursTotal],
            ['Prazniki', _this.holidaysTotal],
            ['Letni dopust', _this.vacationsTotal],
            ['Bolniski dopust', _this.sickLeaveTotal],
            ['Neplacan dopust', _this.unpaidLeaveTotal]
          ],
          styles: { font: 'helvetica', fontStyle: 'normal' },
          headStyles: { fontSize: 10, fillColor: [240, 240, 240], textColor: [0, 0, 0] }
        });

        // Overtime
        doc.autoTable({
          tableWidth: 'wrap',
          margin: {top: 30},
          head: [['Nadure za leto ' + _this.year, 'Ure (H:M)']],
          body: [
            ['Zabelezene nadure', _this.overtimeEarnedTotal],
            ['Koriscene nadure', _this.overtimeUsedTotal],
            ['Stanje nadur', _this.overtimeBalance]
          ],
          styles: { font: 'helvetica', fontStyle: 'normal' },
          headStyles: { fontSize: 10, fillColor: [255, 236, 184], textColor: [0, 0, 0] }
        });

        // Vacation days
        doc.autoTable({
          tableWidth: 'wrap',
          margin: {top: 30},
          head: [['Dopust za leto ' + _this.year, 'Dnevi']],
          body: [
            ['Skupno dni dopusta', _this.vacationDaysTotal],
            ['Korisceni dnevi', _this.vacationDaysUsed],
            ['Preostali dnevi', _this.vacationDaysRemaining]
          ],
          styles: { font: 'helvetica', fontStyle: 'normal' },
          headStyles: { fontSize: 10, fillColor: [198, 239, 206], textColor: [0, 0, 0] }
        });

        // Detailed report
        doc.autoTable({
          margin: {top: 45},
          head: [['#', 'Datum', 'Oseba', 'Tip', 'St. ur']],
          body: body,
          styles: { font: 'helvetica', fontStyle: 'normal' },
          headStyles: { fontSize: 10, fillColor: [220, 220, 220], textColor: [0, 0, 0] }
        });

        // Save with normalized filename (remove special characters from filename)
        const normalizedName = normalizeText(_this.getReadableUser(userId)).replace(/\s+/g, '_');
        doc.save(_this.year + '_' + _this.month + '_evidenca_ur_' + normalizedName + '.pdf');
      },

      retrieveWorkHoursReports() {
        const _this = this;

        _this.isLoading = true;

        // For calendar and monthly view
        let startDate = _this.moment().set({
          date: 1,
          month: _this.$store.getters.getCurrentlySelectedMonth,
          year: _this.$store.getters.getCurrentlySelectedYear
        }).startOf('month');
        let endDate = _this.moment(startDate).endOf('month');

        // For overtime calculation and vacation days, we need the full year's data
        let yearStartDate = _this.moment().set({
          date: 1,
          month: 0, // January
          year: _this.$store.getters.getCurrentlySelectedYear
        }).startOf('month');
        let yearEndDate = _this.moment().set({
          date: 31,
          month: 11, // December
          year: _this.$store.getters.getCurrentlySelectedYear
        }).endOf('month');

        _this.defaultDate = _this.moment(startDate).format('YYYY-MM-DD');

        let calendarApi = _this.$refs.fullCalendar.getApi();
        calendarApi.gotoDate(_this.moment(startDate).format('YYYY-MM-DD'));

        // Get the full year's data for all calculations
        let workHourReports = db.collection('workHoursReports');
        workHourReports
          .where('date', '>=', _this.moment(yearStartDate).toDate())
          .where('date', '<=', _this.moment(yearEndDate).toDate())
          .where('userId', '==', _this.$store.getters.getCurrentlySelectedUser)
          .get()
          .then(yearlyQuerySnapshot => {
            // Get all yearly reports for this user
            const allYearlyReports = yearlyQuerySnapshot.docs.map(doc => doc.data());
            
            // Get monthly reports for display in the table
            const monthlyReports = allYearlyReports.filter(report => {
              const reportDate = _this.moment.unix(report.date.seconds);
              return reportDate.month() === startDate.month() && 
                     reportDate.year() === startDate.year();
            });
            
            // Set the monthly reports for display in the table
            _this.workHoursReports = monthlyReports;
            
            // Create calendar events for the monthly view
            _this.events = [];
            _.each(monthlyReports, function (report) {
              let reportItem = {
                className: report.type.split(' ').join('_'),
                title: report.type,
                date: _this.moment.unix(report.date.seconds).format('YYYY-MM-DD'),
                data: report
              };

              _this.events.push(reportItem);
            });

            // Process the yearly data for vacation day and overtime calculations
            // We use ALL yearly reports for these calculations
            const yearlyVacationReports = allYearlyReports.filter(report => 
              report.type === 'letni dopust'
            );
            
            // Calculate all totals using the appropriate data sets
            _this.calculateTotals(monthlyReports, allYearlyReports, yearlyVacationReports);
            _this.retrieveOvertimeBalanceHistory();
            _this.retrieveVacationAllowance();
            _this.isLoading = false;
          })
          .catch(function (error) {
            console.log('Error getting yearly documents: ', error);
            _this.isLoading = false;
          });
      },

      calculateTotals(monthlyReports, allYearlyReports, yearlyVacationReports) {
        const _this = this;

        // Reset all counters
        _this.workHoursTotal = '0:0';
        _this.holidaysTotal = '0:0';
        _this.vacationsTotal = '0:0';
        _this.sickLeaveTotal = '0:0';
        _this.unpaidLeaveTotal = '0:0';
        _this.overtimeEarnedTotal = '0:0';
        _this.overtimeUsedTotal = '0:0';
        _this.vacationDaysUsed = 0;

        // Calculate monthly totals from the reports for the current month
        _.each(monthlyReports, function (val) {
          if (val.type === 'redno delo' || val.type === 'izobraževanje' || val.type === 'drugo') {
            _this.workHoursTotal = add([_this.workHoursTotal, val.duration])[0] + ':' + add([_this.workHoursTotal, val.duration])[1];
          } else if (val.type === 'letni dopust') {
            _this.vacationsTotal = add([_this.vacationsTotal, val.duration])[0] + ':' + add([_this.vacationsTotal, val.duration])[1];
          } else if (val.type === 'praznik') {
            _this.holidaysTotal = add([_this.holidaysTotal, val.duration])[0] + ':' + add([_this.holidaysTotal, val.duration])[1];
          } else if (val.type === 'bolniški dopust') {
            _this.sickLeaveTotal = add([_this.sickLeaveTotal, val.duration])[0] + ':' + add([_this.sickLeaveTotal, val.duration])[1];
          } else if (val.type === 'neplačan dopust') {
            _this.unpaidLeaveTotal = add([_this.unpaidLeaveTotal, val.duration])[0] + ':' + add([_this.unpaidLeaveTotal, val.duration])[1];
          }
        });

        // Calculate overtime totals from the yearly data
        _.each(allYearlyReports, function (val) {
          if (val.type === 'beleženje nadur') {
            _this.overtimeEarnedTotal = add([_this.overtimeEarnedTotal, val.duration])[0] + ':' + add([_this.overtimeEarnedTotal, val.duration])[1];
          } else if (val.type === 'koriščenje nadur') {
            _this.overtimeUsedTotal = add([_this.overtimeUsedTotal, val.duration])[0] + ':' + add([_this.overtimeUsedTotal, val.duration])[1];
          }
        });

        // Calculate vacation days used from the yearly vacation reports
        _.each(yearlyVacationReports, function (val) {
          // 8 hours is a full workday
          if (val.duration === '8:0' || val.duration === '8:00') {
            _this.vacationDaysUsed += 1;
          } else {
            // For partial days, convert to fractional days (e.g., 4 hours = 0.5 days)
            const durationParts = val.duration.split(':');
            const hours = parseInt(durationParts[0]);
            const minutes = parseInt(durationParts[1]);
            const totalHours = hours + (minutes / 60);
            _this.vacationDaysUsed += (totalHours / 8); // Assuming 8-hour workday
          }
        });

        // Round vacationDaysUsed to nearest 0.5
        _this.vacationDaysUsed = Math.round(_this.vacationDaysUsed * 2) / 2;

        // Calculate remaining vacation days
        _this.vacationDaysRemaining = _this.vacationDaysTotal - _this.vacationDaysUsed;
        _this.vacationDaysRemaining = Math.max(0, _this.vacationDaysRemaining); // Ensure it's never negative

        // Calculate overtime balance for current year only
        const earnedParts = _this.overtimeEarnedTotal.split(':');
        const usedParts = _this.overtimeUsedTotal.split(':');

        const earnedMinutes = parseInt(earnedParts[0]) * 60 + parseInt(earnedParts[1]);
        const usedMinutes = parseInt(usedParts[0]) * 60 + parseInt(usedParts[1]);

        const balanceMinutes = earnedMinutes - usedMinutes;
        const balanceHours = Math.floor(Math.abs(balanceMinutes) / 60);
        const balanceRemainingMinutes = Math.abs(balanceMinutes) % 60;

        if (balanceMinutes >= 0) {
          _this.overtimeBalance = balanceHours + ':' + (balanceRemainingMinutes < 10 ? '0' + balanceRemainingMinutes : balanceRemainingMinutes);
        } else {
          _this.overtimeBalance = '-' + balanceHours + ':' + (balanceRemainingMinutes < 10 ? '0' + balanceRemainingMinutes : balanceRemainingMinutes);
        }

        _this.updateOvertimeBalance();
        _this.updateVacationBalance();
      },

      updateOvertimeBalance() {
        const _this = this;
        const userId = _this.$store.getters.getCurrentlySelectedUser;
        const currentYear = _this.year;

        // Make sure we're using the specific year
        db.collection('overtimeBalance')
          .where('userId', '==', userId)
          .where('year', '==', currentYear)
          .get()
          .then(querySnapshot => {
            if (querySnapshot.empty) {
              // Create new balance record if it doesn't exist
              let newBalanceRef = db.collection('overtimeBalance').doc();
              newBalanceRef.set({
                id: newBalanceRef.id,
                userId: userId,
                year: currentYear,
                balance: _this.overtimeBalance,
                earnedTotal: _this.overtimeEarnedTotal,
                usedTotal: _this.overtimeUsedTotal,
                lastUpdated: new Date()
              });
            } else {
              // Update existing balance
              const balanceDoc = querySnapshot.docs[0];
              balanceDoc.ref.update({
                balance: _this.overtimeBalance,
                earnedTotal: _this.overtimeEarnedTotal,
                usedTotal: _this.overtimeUsedTotal,
                lastUpdated: new Date()
              });
            }
          })
          .catch(error => {
            console.error('Error updating overtime balance:', error);
          });
      },

      handleCalendarDateClick(info) {
        const _this = this;
        console.log(info);
        console.log("handleCalendarDateClick");

        _this.$router.push({name: 'EditWorkHoursReport', params: {date: info.date}});
      },

      handleEventClick(info) {
        const _this = this;
        console.log("handleEventClick", info);
        let eventId = info.event._def.extendedProps.data.id;

        _this.$router.push({name: 'EditWorkHoursReport', params: {id: eventId}})
      },

      handleCalendarDatesRender(info) {
        const _this = this;
        console.log("handleCalendarDatesRender", info);

        let calendarApi = _this.$refs.fullCalendar.getApi();
        const calendarMonth = parseInt(_this.moment(calendarApi.getDate()).format('MM'));
        const calendarMonthZeroBased = calendarMonth - 1; // Convert to 0-based
        const calendarYear = parseInt(_this.moment(calendarApi.getDate()).format('YYYY'));
        
        // Only update if the calendar month differs from the current UI selection
        if (calendarMonth !== _this.month || calendarYear !== _this.year) {
          console.log('Calendar navigation changed month/year, updating state');
          
          // Update store 
          _this.$store.dispatch('setCurrentlySelectedMonth', calendarMonthZeroBased);
          _this.$store.dispatch('setCurrentlySelectedYear', calendarYear);
          
          // Update local variables to match calendar
          _this.month = calendarMonth;
          _this.year = calendarYear;
          
          // Get reports with current filter settings
          _this.retrieveWorkHoursReports();
        }
      },

      handleCalendarDayRender(info) {
        //console.log("handleCalendarDayRender", info);
      },

      deleteWorkHourReportConfirmation(data) {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati evidenco za dan ' + _this.moment.unix(data.date.seconds).format('DD. MM. YYYY') + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteWorkHourReport(data.id)

              case null:

                return

                break

              default:

            }
          })
      },
      deleteWorkHourReport(id) {
        const _this = this
        _this.isLoading = true
        db.collection('workHoursReports').doc(id).delete()
          .then(function () {
            _this.isLoading = false
            _this.retrieveWorkHoursReports()
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting project: ', error)
          })
      },
      getReadableUser(userId) {
        const _this = this

        console.log(userId)

        let userObj = _.filter(_this.users, {'id': userId})[0]
        return userObj.first_name + ' ' + userObj.last_name

      },
      setMonthFilter() {
        const _this = this;
        _this.month = _this.month;
        console.log(_this.month);
      },
      setYearFilter() {
        console.log(_this.year);
      },

      retrieveOvertimeBalanceHistory() {
        const _this = this;
        const userId = _this.$store.getters.getCurrentlySelectedUser;

        db.collection('overtimeBalance')
          .where('userId', '==', userId)
          .orderBy('year', 'desc')
          .get()
          .then(querySnapshot => {
            _this.overtimeBalanceHistory = querySnapshot.docs.map(doc => doc.data());

            // Check if we have a record for the current year
            const hasCurrentYearRecord = _this.overtimeBalanceHistory.some(record =>
              record.year === _this.year
            );

            // If we don't have a record for the current year, create one
            if (!hasCurrentYearRecord && _this.overtimeBalance) {
              _this.updateOvertimeBalance();
            }

            console.log('Overtime balance history by year:', _this.overtimeBalanceHistory);
          })
          .catch(error => {
            console.error('Error retrieving overtime balance history:', error);
          });
      },

      retrieveVacationAllowance() {
        const _this = this;
        const userId = _this.$store.getters.getCurrentlySelectedUser;
        
        console.log('Retrieving vacation allowance for user:', userId, 'and year:', _this.year);

        // First check if we have vacation days settings in the vacationDaysReports collection
        // This is the collection used by the "Pregled evidence dopusta" page
        db.collection('vacationDaysReports')
          .where('userId', '==', userId)
          .where('year', '==', _this.year)
          .get()
          .then(querySnapshot => {
            if (!querySnapshot.empty) {
              // Found existing vacation days report
              const vacationData = querySnapshot.docs[0].data();
              console.log('Found vacation days report:', vacationData);
              
              // Use the daysTotal from the report WITHOUT any default fallback
              // This ensures we use exactly what was set in the admin interface
              _this.vacationDaysTotal = vacationData.daysTotal;
              _this.vacationBalance = vacationData;

              console.log('Set vacation days total exactly to:', _this.vacationDaysTotal);
              
              // Recalculate remaining days
              _this.vacationDaysRemaining = _this.vacationDaysTotal - _this.vacationDaysUsed;
              console.log('Vacation days used:', _this.vacationDaysUsed);
              console.log('Vacation days remaining:', _this.vacationDaysRemaining);
            } else {
              console.log('No vacation days report found, no vacation days allocated');
              // No vacation days report set for this year, set to 0 (no allocation)
              _this.vacationDaysTotal = 0; // No default value
              _this.vacationDaysRemaining = 0;
              
              // We don't create a record automatically here as that should be done by an admin
            }
          })
          .catch(error => {
            console.error('Error retrieving vacation days report:', error);
          });
      },

      updateVacationBalance() {
        const _this = this;
        const userId = _this.$store.getters.getCurrentlySelectedUser;

        // Update or create vacation balance record
        db.collection('vacationAllowance')
          .where('userId', '==', userId)
          .where('year', '==', _this.year)
          .get()
          .then(querySnapshot => {
            if (querySnapshot.empty) {
              // Create new record
              let newVacationRef = db.collection('vacationAllowance').doc();
              newVacationRef.set({
                id: newVacationRef.id,
                userId: userId,
                year: _this.year,
                totalDays: _this.vacationDaysTotal,
                usedDays: _this.vacationDaysUsed,
                remainingDays: _this.vacationDaysRemaining,
                lastUpdated: new Date()
              });
            } else {
              // Update existing record
              const vacationDoc = querySnapshot.docs[0];
              vacationDoc.ref.update({
                usedDays: _this.vacationDaysUsed,
                remainingDays: _this.vacationDaysRemaining,
                lastUpdated: new Date()
              });
            }
          })
          .catch(error => {
            console.error('Error updating vacation balance:', error);
          });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/user/WorkHoursReport.vue